const duoji_Block = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E6':
            return `
            <category 
                name="%{BKY_CATEGORY_DUOJI}" 
                id="SteeringEngine"
                colour="#4C97FF"
                secondaryColour="#4385E1"
                showLabelButton="true">
                <block type="motor_setServo_E6">
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setServoTime_E6">
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                
                <block type="E6_motor_setMagneticServoDegreeTime">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">90</field>
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="E6_motor_setMagneticServoDegreeSpeed">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">90</field>
                        </shadow>
                    </value>
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="E6_motor_setMagneticServoCodeMotor">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">360</field>
                        </shadow>
                    </value>
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="E6_motor_setSeeringEngine">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">135</field>
                        </shadow>
                    </value>
                </block>
                <block type="E6_motor_setSeeringEngineTime">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">135</field>
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setOneServo">
                    <value name="CHANNEL">
                        <shadow type="math_number">
                            <field name="NUM"></field>
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM"></field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
            </category>
                `;
        case 'M6':
            return `
            <category 
                name="%{BKY_CATEGORY_DUOJI}" 
                id="SteeringEngine"
                colour="#4C97FF"
                secondaryColour="#4385E1"
                showLabelButton="true">
                
                <block type="motor_setServo_M6">
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setServoTime_M6">
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                
                <block type="M6_motor_setMagneticServoDegreeTime">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">90</field>
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="M6_motor_setMagneticServoDegreeSpeed">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">90</field>
                        </shadow>
                    </value>
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="M6_motor_setMagneticServoCodeMotor">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">360</field>
                        </shadow>
                    </value>
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="M6_motor_setSeeringEngine">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">135</field>
                        </shadow>
                    </value>
                </block>
                <block type="M6_motor_setSeeringEngineTime">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">135</field>
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setOneServo">
                    <value name="CHANNEL">
                        <shadow type="math_number">
                            <field name="NUM"></field>
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM"></field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
            </category>
                `;
        case 'C6':
            return `
                    <category 
                        name="%{BKY_CATEGORY_DUOJI}" 
                        id="SteeringEngine"
                        colour="#4C97FF"
                        secondaryColour="#4385E1"
                        showLabelButton="true">
                        
                        <block type="motor_setServo_M6">
                            <value name="ANGLE">
                                <shadow type="motor_angle_menu_three">
                                </shadow>
                            </value>
                        </block>
                        <block type="motor_setServoTime_M6">
                            <value name="ANGLE">
                                <shadow type="motor_angle_menu_three">
                                </shadow>
                            </value>
                            <value name="TIME">
                                <shadow type="math_number">
                                    <field name="NUM">1000</field>
                                </shadow>
                            </value>
                        </block>
                        ${blockSeparator}
                        
                        <block type="M6_motor_setMagneticServoDegreeTime">
                            <value name="ANGLE">
                                <shadow type="math_number">
                                    <field name="NUM">90</field>
                                </shadow>
                            </value>
                            <value name="TIME">
                                <shadow type="math_number">
                                    <field name="NUM">1000</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="M6_motor_setMagneticServoDegreeSpeed">
                            <value name="ANGLE">
                                <shadow type="math_number">
                                    <field name="NUM">90</field>
                                </shadow>
                            </value>
                            <value name="SPEED">
                                <shadow type="math_number">
                                    <field name="NUM">50</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="M6_motor_setMagneticServoCodeMotor">
                            <value name="ANGLE">
                                <shadow type="math_number">
                                    <field name="NUM">360</field>
                                </shadow>
                            </value>
                            <value name="SPEED">
                                <shadow type="math_number">
                                    <field name="NUM">50</field>
                                </shadow>
                            </value>
                        </block>
                        ${blockSeparator}
                        <block type="M6_motor_setSeeringEngine">
                            <value name="ANGLE">
                                <shadow type="math_number">
                                    <field name="NUM">135</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="M6_motor_setSeeringEngineTime">
                            <value name="ANGLE">
                                <shadow type="math_number">
                                    <field name="NUM">135</field>
                                </shadow>
                            </value>
                            <value name="TIME">
                                <shadow type="math_number">
                                    <field name="NUM">1000</field>
                                </shadow>
                            </value>
                        </block>
                        ${blockSeparator}
                        <block type="motor_setOneServo">
                            <value name="CHANNEL">
                                <shadow type="math_number">
                                    <field name="NUM"></field>
                                </shadow>
                            </value>
                            <value name="ANGLE">
                                <shadow type="motor_angle_menu_three">
                                </shadow>
                            </value>
                            <value name="TIME">
                                <shadow type="math_number">
                                    <field name="NUM"></field>
                                </shadow>
                            </value>
                        </block>
                        ${blockSeparator}
                    </category>
                        `;
        default:
            return `
                <category 
                    name="%{BKY_CATEGORY_DUOJI}" 
                    id="SteeringEngine"
                    colour="#4C97FF"
                    secondaryColour="#4385E1"
                    showLabelButton="true">
                </category>
                `;
    }
};

export default duoji_Block;
